<template>
  <zm-alert v-if="numberTips" class="number-item opc-zsched__desc is-warning opc-zsched__alert" :type="numberTips.type">
    <div class="number-tips-info" ref="numberTipsRef">
      <i class="billing-icon-warning" v-if="numberTips.type === 'warning'" />
      <p v-html="numberTips.text"></p>
    </div>
  </zm-alert>
</template>

<script>
import { getCommonContactSalesLink } from '@/utils/i18n-shortcuts';
export default {
  props: {
    selectedUsers: {
      type: Number,
      default: 0
    },
    maxUsers: {
      type: Number,
      default: 99
    }
  },
  data() {
    return {
      contactSalesLink: getCommonContactSalesLink()
    };
  },
  computed: {
    numberTips() {
      if (this.selectedUsers >= this.maxUsers) {
        return {
          text: this.$t('billing.scheduler.more_than_99_users', [this.maxUsers, this.contactSalesLink]),
          type: 'warning',
        };
      }
      return null;
    },
  },
};
</script>

<style scoped lang="scss">
.opc-zsched__alert {
  margin-top: 12px;
  color: #815A30;

  a {
    color: #0B5CFF
  }
}
</style>
  